import { Component, OnInit, OnChanges, SimpleChanges, Input } from "@angular/core";
import { ChartType } from "chart.js";
import { MultiDataSet, Label } from "ng2-charts";
import { GraphicData } from "../../schema/graphic-data";

@Component({
    selector: "app-graphic-doughnut",
    templateUrl: "./graphic-doughnut.component.html",
    styleUrls: ["./graphic-doughnut.component.scss"]
})
export class GraphicDoughnutComponent implements OnInit, OnChanges {
    @Input("data")
    public data: GraphicData;

    public doughnutChartLabels: Label[];
    public barChartLegend;
    public doughnutChartData: MultiDataSet;
    public doughnutChartType: ChartType;

    constructor() {
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];
        this.doughnutChartType = "doughnut";
        this.barChartLegend = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && JSON.stringify(changes.data.previousValue) != JSON.stringify(changes.data.currentValue)) {
            this.manageData(changes.data.currentValue);
        }
    }

    ngOnInit() {
        this.manageData(this.data);
    }

    private manageData(data: GraphicData) {
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];

        if (data == undefined) return;

        if (data.keys.length <= 0) return;

        const tempValues: number[][] = [];
        const tempLabels: string[] = [];
        data.keys.forEach((key, i) => {
            tempValues.push([]);
            data.group.forEach((group, j) => {
                if (!tempLabels.includes(group.group)) tempLabels.push(group.group);

                tempValues[i].push(group.values[i]);
            });
        });

        this.doughnutChartLabels = tempLabels;
        this.doughnutChartData = tempValues;
    }
}
